//return all items from array a that are not present in array b
export function not(a: any[], b: any[]) {
  return a.filter(
    (value) =>
      !b.some((item) => item.campaign_shared_uid === value.campaign_shared_uid)
  );
}

//find common items between two arrays
export function intersection(a: readonly number[], b: any[]) {
  return b.filter((item) => a.includes(item.campaign_shared_uid));
}

//-- Function to get unique search terms with duplicates search terms without grouping(Search Term Operations)
// update getUniqueSearchTermsWithDuplicates according to current requirement(step1)
export const getUniqueSearchTermsWithDuplicates = (
  data: any[],
  countKey: string,
  rowsKey: string
) => {
  const searchTermMap = new Map();

  // First pass: collect all rows for each search term
  data.forEach((row) => {
    const searchTerm = row.search_term;

    if (!searchTermMap.has(searchTerm)) {
      searchTermMap.set(searchTerm, []);
    }
    searchTermMap.get(searchTerm).push(row);
  });

  // Return ALL rows (including duplicates) with count and duplicate info attached
  const result: any[] = [];

  searchTermMap.forEach((allRows) => {
    // Process each row for this search term
    allRows.forEach((currentRow: any) => {
      // Get OTHER rows (excluding current row)
      const otherRows = allRows.filter((row: any) => row !== currentRow);

      result.push({
        ...currentRow,
        [countKey]: otherRows.length,
        [rowsKey]: otherRows,
      });
    });
  });

  return result;
};

export const countNonNegativeInadgroup = (data: any[]) => {
  // Create a map to group by search_term
  const searchTermMap = new Map<string, Map<string, any[]>>();

  // Group data by search_term and then by non_negative_in_ad_group_shared_uid
  data.forEach((row) => {
    const searchTerm = row.search_term;
    const adGroupUid = row.non_negative_in_ad_group_shared_uid;

    if (!searchTermMap.has(searchTerm)) {
      searchTermMap.set(searchTerm, new Map());
    }

    const adGroupMap = searchTermMap.get(searchTerm)!;

    if (!adGroupMap.has(adGroupUid)) {
      adGroupMap.set(adGroupUid, []);
    }

    adGroupMap.get(adGroupUid)!.push(row);
  });

  // Convert to result array
  const result: any[] = [];

  searchTermMap.forEach((adGroupMap) => {
    const adGroupUids = Array.from(adGroupMap.keys());
    const totalUniqueAdGroups = adGroupUids.length;

    // Process each ad group for this search term
    adGroupUids.forEach((currentAdGroupUid) => {
      const rowsForCurrentAdGroup = adGroupMap.get(currentAdGroupUid)!;

      // Find rows from OTHER ad groups (different non_negative_in_ad_group_shared_uid)
      const otherAdGroupRows: any[] = [];

      adGroupUids.forEach((otherAdGroupUid) => {
        if (otherAdGroupUid !== currentAdGroupUid) {
          const otherRows = adGroupMap.get(otherAdGroupUid)!;
          otherAdGroupRows.push(...otherRows);
        }
      });

      // Deduplicate otherAdGroupRows by non_negative_in_ad_group_name
      // Keep only the first occurrence of each unique ad group name
      const uniqueOtherAdGroupRows: any[] = [];
      const seenAdGroupNames = new Set<string>();

      otherAdGroupRows.forEach((row) => {
        const adGroupName = row.non_negative_in_ad_group_name;
        if (!seenAdGroupNames.has(adGroupName)) {
          seenAdGroupNames.add(adGroupName);
          uniqueOtherAdGroupRows.push(row);
        }
      });

      // Add result for each row in current ad group
      rowsForCurrentAdGroup.forEach((row) => {
        result.push({
          ...row,
          noOfAdgroupsSetWithThisTerm: totalUniqueAdGroups,
          otherNonNegativeAdgroupsCount: uniqueOtherAdGroupRows.length,
          otherNonNegativeAdgroupsRows: uniqueOtherAdGroupRows,
        });
      });
    });
  });

  return result;
};
